import "./style.scss";
import "./style-mob.scss";
import { Fragment } from "react/jsx-runtime";
import { AdvantagesCardsConst } from "@/src/constants/advantages";
import AdvantagesCard from "./AdvantagesCard/AdvantagesCard";
import AdvantagesSlider from "./AdvantagesSlider/AdvantagesSlider";

const Advantages = () => {
  return (
    <div className="advantages container section-margin-top">
      <div className="advantages-title">
        <p>Главные преимущества МШМБ</p>
      </div>
      <div className="advantages-content">
        <div className="advantages-cards">
          {AdvantagesCardsConst.map((card, index) => (
            <Fragment key={index}>
              <AdvantagesCard name={card.name} image={card.image} />
            </Fragment>
          ))}
        </div>
        {/* <div className="advantages-line"></div> */}
        <AdvantagesSlider />
      </div>
    </div>
  );
};

export default Advantages;
